import { makeStyles } from '@material-ui/core'

const drawerWidth = 210

export const useStyles = makeStyles(theme => ({
  // --- LAYOUT GLOBAL E ROOT ---
  root: {
    display: 'flex',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    ...theme.scrollbarStylesSoft,
    top: props => (props.hasAnnouncement ? 30 : 0),
    backgroundColor: theme.palette.fancyBackground,
    '& .MuiButton-outlinedPrimary': {
      color: theme.palette.primary,
      border:
        theme.mode === 'light'
          ? '1px solid rgba(0 124 102)'
          : '1px solid rgba(255, 255, 255, 0.5)'
    },
    '& .MuiTab-textColorPrimary.Mui-selected': {
      color: theme.palette.blue_300.main
    },
    '& .MuiToolbar-gutters': {
      padding: '0 0 0 10px'
    },
    '& .MuiPaper-elevation4': {
      boxShadow: 'none !important'
    },
    '& .MuiDivider-root': {
      margin: '10px'
    },
    '& .MuiListItemIcon-root': {
      '& svg': {
        with: '50px' // Nota: Verificar se o correto seria 'width'
      }
    },
    '& .MuiListItem-root': {
      transition: 'color 0.3s, transform 0.3s',
      '&:hover': {
        background: theme.palette.blue_50.main,
        color: theme.palette.white_100.main,
        transform: 'translateX(5px)'
      }
    },
    '& .MuiTypography-body2': {}
  },
  lastAnnouncement: {
    display: props => (props.topOffset ? 'block' : 'none'),
    position: 'absolute',
    top: 0,
    bottom: 24,
    left: 0,
    right: 0
  },

  // --- APP BAR / TOOLBAR (TOPO) ---
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    backgroundColor: props =>
      props.isImpersonated
        ? theme.palette.secondary.main
        : theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gradient.main
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
    // [theme.breakpoints.down('sm')]: {
    //   display: 'none'
    // }
  },
  appBarSpacer: {
    minHeight: '48px'
  },
  toolbar: {
    color: theme.palette.white_100.main,
    background: props =>
      props.isImpersonated
        ? theme.palette.secondary.main
        : theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gradient.main,
    display: 'flex',
    justifyContent: 'space-between',
    // borderBottom:
    //   theme.palette.type === 'dark'
    //     ? '1px solid' + theme.palette.dark_stroke.main
    //     : '1px solid' + theme.palette.gray_stroke.main,
    boxShadow:
      theme.palette.type === 'dark'
        ? '0px 2px 4px rgba(0, 0, 0, 0.1)' // Sombra um pouco mais densa para o dark mode aparecer
        : '0px 2px 8px rgba(0, 0, 0, 0.05)',
    [theme.breakpoints.down('sm')]: {
      minHeight: '60px'
    }
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '48px',
    padding: '0 16px'
  },
  headerMenu: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 16,
    gap: 10
  },
  storageUsageWrapper: {
    minWidth: 190,
    maxWidth: 230,
    padding: '4px 10px',
    borderRadius: 8,
    backgroundColor:
      theme.palette.type === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(255, 255, 255, 0.18)',
    border:
      theme.palette.type === 'dark'
        ? '1px solid rgba(255, 255, 255, 0.12)'
        : '1px solid rgba(255, 255, 255, 0.3)'
  },
  storageUsageTitle: {
    fontSize: '0.7rem',
    fontWeight: 600,
    lineHeight: 1.1,
    opacity: 0.95,
    color: theme.palette.white_100.main
  },
  storageUsageProgress: {
    height: 6,
    borderRadius: 999,
    marginTop: 4,
    marginBottom: 4,
    backgroundColor:
      theme.palette.type === 'dark'
        ? 'rgba(255, 255, 255, 0.12)'
        : 'rgba(255, 255, 255, 0.35)',
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: theme.palette.blue_300.main
    },
    '& .MuiLinearProgress-barColorSecondary': {
      backgroundColor: '#ff9f43'
    }
  },
  storageUsageText: {
    fontSize: '0.68rem',
    lineHeight: 1.1,
    color: theme.palette.white_100.main,
    opacity: 0.95
  },
  storageUsagePercent: {
    opacity: 0.85
  },
  appBarMenuIcons: {
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    fontSize: 14,
    color: theme.palette.white_100.main,
    marginRight: 16
  },
  boxExpirationTime: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: theme.palette.type === 'dark' ? theme.palette.yellow_500.main : theme.palette.white_100.main
  },
  boxHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '70px'
  },

  // --- LOGO E AVATAR ---
  logo: {
    width: '138px',
    logo: theme.logo,
    content: `url("${theme.calculatedLogo()}")`
  },
  appLogoFavicon: {
    width: '25px',
    maxHeight: '25px',
    padding: '0px',
    margin: '0px',
    content:
      'url(' +
      (theme.appLogoFavicon ? theme.appLogoFavicon : '/vector/icone.svg') +
      ')'
  },
  hideLogo: {
    display: 'none'
  },
  avatar: {
    width: '100%'
  },

  // --- USUÁRIO E BOXES DE SAUDAÇÃO ---
  helloBox: {
    textAlign: 'right', // Mantido da primeira versão
    display: 'flex', // Adicionado da segunda versão
    flexDirection: 'column',
    padding: '4px 15px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  userName: {
    fontWeight: 'bold',
    fontSize: '1rem'
  },
  impersonationBadge: {
    marginTop: 4,
    fontSize: '0.68rem',
    fontWeight: 700,
    color: theme.palette.secondary.main,
    textTransform: 'uppercase',
    letterSpacing: '0.04em'
  },

  // --- DRAWER / MENU LATERAL ---
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    overflowY: 'clip',
    ...theme.scrollbarStylesSoft,
    '& .MuiDrawer-paperAnchorDockedLeft': {
      borderRight:
        theme.palette.type === 'dark'
          ? '1px solid' + theme.palette.dark_700.main
          : '1px solid' + theme.palette.gray_stroke.main
    }
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    overflowY: 'clip',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: 50,
    '& .MuiDrawer-paperAnchorDockedLeft': {
      borderRight:
        theme.palette.type === 'dark'
          ? '1px solid' + theme.palette.dark_700.main
          : '1px solid' + theme.palette.gray_stroke.main
    },
    [theme.breakpoints.up('lg')]: {
      width: 56
    }
  },
  chatDrawer: {
    '& .MuiDrawer-paper': {
      top: props => (props.hasAnnouncement ? 99 : 53),
      height: props =>
        props.hasAnnouncement ? 'calc(100% - 119px)' : 'calc(100% - 54px)'
    },
    [theme.breakpoints.up('lg')]: {
      '& .MuiDrawer-paper': {
        top: props => (props.hasAnnouncement ? 82 : 53),
        height: props =>
          props.hasAnnouncement ? 'calc(100% - 82px)' : 'calc(100% - 53px)'
      }
    }
  },

  // --- BOTÕES E ITENS DE MENU ---
  menuButton: {
    display: 'flex',
    background: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  buttonHiddenMenu: {
    background: 'transparent',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  iconButton: {
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.white_100.main
    }
  },
  menuList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    '& .MuiListItemText-root': {
      marginLeft: '-14px'
    }
  },
  menuDropdown: {
    background: theme.palette.blue_300.main
  },
  menu: {
    '& .MuiPaper-root': {
      right: '16px !important',
      left: 'auto !important',
      top: '56px !important',
      borderRadius: '10px',
      marginTop: '4px',
      padding: '0 4px 4px 4px',
      border:
        theme.palette.type === 'dark'
          ? '1px solid' + theme.palette.dark_stroke.main
          : '1px solid' + theme.palette.gray_stroke.main
    },
    '& .MuiList-root': {}
  },
  menuItem: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '0.875rem',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  menuItemLogout: {
    fontSize: '0.875rem',
    margin: '0 8px',
    borderRadius: '6px',
    color: theme.palette.blue_300.main,
    border: '1px solid' + theme.palette.blue_300.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.3s, color 0.3s',
    '&:hover': {
      color: theme.palette.white_100.main,
      backgroundColor: theme.palette.blue_300.main
    }
  },
  ListSubheader: {
    height: 26,
    marginTop: '-15px',
    marginBottom: '-10px'
  },
  listItemLinkIcon: {
    width: '20px',
    height: '20px',
    [theme.breakpoints.up('lg')]: {
      width: '24px',
      height: '24px'
    }
  },

  // --- CONTEÚDO E COMPONENTES DE INTERFACE ---
  content: {
    flex: 1,
    overflow: 'auto',
    ...theme.scrollbarStylesSoft
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  containerWithScroll: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'auto',
    overflowX: 'clip',
    ...theme.scrollbarStyles
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column'
  },
  divider: {
    margin: '10px 0'
  },
  NotificationsPopOver: {
    // color: theme.barraSuperior.secondary.main,
  },

  //Mobile
  appBarSpacerMobile: {
    minHeight: '60px'
  },
  iconMobileContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: 8
  },
  iconMobile: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& img': {
      height: 30,
      width: 30
    },
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.white_100.main
    }
  },
  iconButtonContainer: {
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    padding: 8
  }
}))
